import { useEffect, useRef, useState } from 'react';
import { fetchWithAuth } from '../../../api/apiClient';
import { hasSyntaxTerms } from '../../../utils/searchTermSplit';

const SYNTAX_SEARCH_DEBOUNCE_MS = 300;

export function useDeckSyntaxSearch({ deckId, searchTerm }) {
  const [matchingCardIds, setMatchingCardIds] = useState(null); // null = keine Suche aktiv, Set = IDs die matchen
  const syntaxSearchTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (syntaxSearchTimeoutRef.current) {
        clearTimeout(syntaxSearchTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (syntaxSearchTimeoutRef.current) {
      clearTimeout(syntaxSearchTimeoutRef.current);
    }

    const trimmedTerm = (searchTerm || '').trim();

    if (!trimmedTerm || !deckId) {
      setMatchingCardIds(null);
      return;
    }

    if (!hasSyntaxTerms(trimmedTerm)) {
      setMatchingCardIds(null);
      return;
    }

    syntaxSearchTimeoutRef.current = setTimeout(async () => {
      try {
        const response = await fetchWithAuth(
          `/api/decks/${deckId}/filter?q=${encodeURIComponent(trimmedTerm)}`
        );
        const data = await response.json();

        if (data.matchingIds && Array.isArray(data.matchingIds)) {
          setMatchingCardIds(new Set(data.matchingIds));
        } else {
          setMatchingCardIds(new Set());
        }
      } catch (error) {
        console.error('Fehler bei Syntax-Suche:', error);
        setMatchingCardIds(null);
      }
    }, SYNTAX_SEARCH_DEBOUNCE_MS);
  }, [searchTerm, deckId]);

  return matchingCardIds;
}
